import IconButton from '@/_application/core/components/ui/icon-button';
import {Image} from '@/_application/core/components/ui/image';
import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import {Aggregation} from '__generated__/__types__';
import FilterItem from './filter-item';
import {useTranslation} from 'next-i18next';
import {useMemo} from 'react';
import {ORDER_DOCS} from '@/framework/static/filter-attribute-code-value-type';

const GrayNextArrow = getImageAssetUrl('icons/gray-next-arrow.png');

interface FilterListProps {
    aggregation: Aggregation;
    query: string[] | undefined;
    onChange: (attribute_code: string, buttonValue: any, isSelected: boolean) => void;
    onSeeMore: () => void;
}

const FilterList: React.FC<FilterListProps> = ({aggregation, query, onChange, onSeeMore}) => {
    const {t} = useTranslation();

    const getDefaultSatus = (value: string) => {
        if (!query?.length) return false;

        const index = query.findIndex(item => item === value);
        if (index === -1) return false;

        return true;
    };

    const selectAggregation = (attribute_code: string, value: string, isSelected: boolean) => {
        onChange(attribute_code, value, isSelected);
    };

    if (!aggregation.options?.length) {
        return <></>;
    }

    const validOptions = useMemo(() => {
        return aggregation.options?.filter(item => item?.value !== ORDER_DOCS) ?? [];
    }, [JSON.stringify(aggregation)]);

    return (
        <div className="w-full bg-white">
            <div className="flex content-center justify-between">
                <p className="text-sm font-bold text-KPZ_text_1st">{aggregation.label}</p>
                {aggregation.attribute_code === 'brand' && (
                    <IconButton
                        data-testid={'see-more-brand-button'}
                        whileTap={{translateX: 4}}
                        onClick={onSeeMore}
                        className="flex flex-row-reverse items-center justify-center gap-3"
                        label={t('text-load-more')}
                        labelClassName="text-sm text-KPZ_text_1st"
                        icon={
                            <div className="flex h-3 w-2 items-center justify-center">
                                <Image src={GrayNextArrow} alt="Icon Arrow" height={12} width={5} />
                            </div>
                        }
                    />
                )}
            </div>

            <div>
                <Swiper slidesPerView={'auto'} freeMode={true} spaceBetween={10} className="mySwiper">
                    {validOptions.map(item => (
                        <SwiperSlide key={item?.value} style={{width: 'auto'}}>
                            <FilterItem
                                label={item?.label ?? ''}
                                status={getDefaultSatus(item?.value ?? '')}
                                onChange={(isSelected: boolean) =>
                                    selectAggregation(aggregation.attribute_code, item?.value ?? '', isSelected)
                                }
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default FilterList;
